<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      {{ 'ASSOCIATIONS.APP_ACCESS_MODAL.TITLE' | translate: { appName: businessAppName$ | async } }}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="description">
      {{
        'ASSOCIATIONS.APP_ACCESS_MODAL.DESCRIPTION'
          | translate: { contactName: contactName, companyName: companyName, appName: businessAppName$ | async }
      }}
    </div>
    <div
      [innerHTML]="
        'ASSOCIATIONS.APP_ACCESS_MODAL.PERMISSIONS_INFO'
          | translate: { contactName: contactName, companyName: companyName, appName: businessAppName$ | async }
      "
    ></div>
  </mat-card-content>
  <mat-card-actions align="end">
    <div class="secondary-card-action">
      <mat-checkbox [(ngModel)]="sendWelcomeEmail">{{
        'ASSOCIATIONS.APP_ACCESS_MODAL.SEND_WELCOME_EMAIL' | translate
      }}</mat-checkbox>
    </div>
    <div class="primary-card-actions">
      <button mat-flat-button color="primary" (click)="invite()">
        {{ 'ASSOCIATIONS.APP_ACCESS_MODAL.INVITE' | translate }}
      </button>
      <button mat-stroked-button (click)="close()">{{ 'ASSOCIATIONS.APP_ACCESS_MODAL.CANCEL' | translate }}</button>
    </div>
  </mat-card-actions>
</mat-card>
